import BaseComponent from '../../../js/base-component';

class CareProductsStepFour extends BaseComponent {
    constructor(options) {
        super(options);

        let providers = this.element.querySelectorAll('input[name="provider"]') || '';
        this.checked = this.element.querySelector('input[name="provider"]:checked');
        this.buttons = this.element.querySelector('.u-care-products__buttons');

        this.providerChange = this.element.querySelector('.provider-change') || '';
        this.providerChangeCheck = this.element.querySelector('#providerchange') || '';
        this.form = this.element.querySelector('form') || '';

        providers.forEach((ele) => {
            ele.addEventListener("click", (e) => { this.checkRadio( e.target.value ) });
        });

        if ( this.providerChangeCheck ) {
            this.providerChangeCheck.addEventListener('click', this.sendForm);
        }

        if (this.checked !== null) {
            this.checkRadio( this.checked.value );
        }
    }

    onInit() {}

    checkRadio = (state) => {
        if ( state === '0' ) {
            this.providerChange.classList.add('hidden');
            if ( window.matchMedia('(max-width: 47.9375rem)').matches ) this.buttons.style.display = 'block';
        }

        if ( state === '1' ) {
           this.providerChange.classList.remove('hidden');
           if ( window.matchMedia('(max-width: 47.9375rem)').matches ) this.buttons.style.display = 'none';
        }
    }

    sendForm = () => {
        let applicant = this.element.querySelector('input[name="applicant"]:checked') || '';

        if ( window.matchMedia('(max-width: 47.9375rem)').matches && applicant !== '') {
           this.form.submit();
        }
    }
}

export default {
    name: 'CareProductsStepFour',
    definition: CareProductsStepFour
};